import { useCallback, useEffect, useMemo, useState } from 'react'
import { LocationDTO } from '@sales-center/common'

const pageSize = 6

export function useLocationPagination(allLocations: LocationDTO[]) {
  const pageCount = Math.ceil(allLocations.length / pageSize)

  const [page, setPage] = useState(1)

  useEffect(() => void setPage(1), [pageCount])

  const pagedLocations = useMemo(() => {
    const locations: LocationDTO[][] = []
    for (let index = 0; index < allLocations.length; index += pageSize) {
      const start = index
      const end = index + pageSize
      const page = allLocations.slice(start, end)
      locations.push(page)
    }
    return locations
  }, [allLocations])

  const onChange = useCallback(
    (_, newPage: number) => void setPage(newPage),
    [],
  )

  return {
    page,
    count: pageCount,
    currentPage: pagedLocations[page - 1] ?? [],
    onChange,
  }
}
